var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcProf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 18C4.5 23.6569 4.5 29.4853 6.47703 31.2426C8.45406 33 11.636 33 18 33C24.364 33 27.5459 33 29.523 31.2426C31.5 29.4853 31.5 23.6569 31.5 18",
    stroke: "currentColor",
    strokeOpacity: 0.86,
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9905 21.3029L31.2869 18.5139C31.9032 18.329 32.2114 18.2366 32.4396 18.0532C32.6388 17.8931 32.7939 17.6848 32.89 17.4479C33 17.1767 33 16.8549 33 16.2115C33 13.6804 33 12.4149 32.5054 11.449C32.0751 10.6086 31.3914 9.92489 30.551 9.49457C29.5851 9 28.3196 9 25.7885 9H10.2115C7.68041 9 6.41488 9 5.44901 9.49457C4.60863 9.92489 3.92489 10.6086 3.49457 11.449C3 12.4149 3 13.6804 3 16.2115C3 16.8549 3 17.1767 3.11005 17.4479C3.20615 17.6848 3.36118 17.8931 3.56044 18.0532C3.78861 18.2366 4.09677 18.329 4.71309 18.5139L14.0095 21.3029",
    stroke: "currentColor",
    strokeOpacity: 0.86,
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 18.75H15C14.5858 18.75 14.25 19.0858 14.25 19.5V22.7422C14.25 23.0489 14.4367 23.3247 14.7215 23.4386L15.7717 23.8587C17.2021 24.4308 18.7979 24.4308 20.2283 23.8587L21.2785 23.4386C21.5633 23.3247 21.75 23.0489 21.75 22.7422V19.5C21.75 19.0858 21.4142 18.75 21 18.75Z",
    stroke: "currentColor",
    strokeOpacity: 0.86,
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7563 6C14.3741 4.25221 16.041 3 18.0003 3C19.9596 3 21.6265 4.25221 22.2442 6",
    stroke: "currentColor",
    strokeOpacity: 0.86,
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProf);
export default __webpack_public_path__ + "static/media/ic_prof.29f0956ea4b74df268d82b60232fba87.svg";
export { ForwardRef as ReactComponent };